// extracted by mini-css-extract-plugin
module.exports = {"root":"Textarea_root___pSeF","error":"Textarea_error__spJFw","readonly":"Textarea_readonly__3mgBm","disabled":"Textarea_disabled__3PRBl"};